class FixedWeight {
    constructor({
        value = 0,
    }) {
        this.kind = 'fixed'
        this.value = value
    }

    toJSON() {
        return {
            kind: this.kind,
            value: Number(this.value),
        }
    }
}

export default FixedWeight
